import { RequestBuilder } from '@hereisyourgitanton/crm-api2';
import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { TRADGINE_DATA_API_BASE_URL } from '../api-base-url.token';
import { OrganizationDocumentResponseDto } from '../schemas/organization-document-response.dto';

@Injectable({ providedIn: 'root' })
export class OrganizationDocumentApi {
    private readonly builder = new RequestBuilder(inject(HttpClient));
    private readonly controllerUrl = `${inject(TRADGINE_DATA_API_BASE_URL)}/organizationDocument`;

    getAll() {
        return this.builder
            .url(`${this.controllerUrl}/getAll`)
            .get()
            .json<OrganizationDocumentResponseDto[]>()
            .build()
            .send();
    }

    getById(id: number) {
        return this.builder
            .url(`${this.controllerUrl}/getById`)
            .get()
            .json<OrganizationDocumentResponseDto>()
            .withHttpParams(new HttpParams().set('id', id))
            .build()
            .send();
    }
}
